import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/queryClient";
import { getScoringAlgorithm } from "@/api/endpoints/maturity";

export function useGetScoringAlgorithm() {
  return useQuery({
    queryKey: queryKeys.maturity.scoringAlgorithm(),
    queryFn: getScoringAlgorithm,
    staleTime: Infinity,
  });
}
